import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";
import {BlackoutDateProps} from "../types/BlackoutPeriod";

export interface CreateCampaignDataProps {
    title: string;
    active: boolean;
}

export const getCheckoutHistory = async (domain: string, checkoutId: number): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `checkouts/${checkoutId}`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
    });
}